<template>
<div>
  <Top />
  <div class="maindiv index-wrap">
    <Banner :banner="banner" ref="banner"/>
    <News :news="news"/>
    <Notice :notice="notice"/>
<!--    <Aedu :info="academicCategoryList"/>-->
<!--    <Cedu :info="selfStudyCategoryList"/>-->
<!--    <Dedu :info="distanceCategoryList"/>-->
<!--    <Train :train="train"/>-->
    <!-- <Quick /> -->
  </div>
  <Bottom />
</div>
</template>

<script>
import Top from './top.vue'
import Banner from './banner.vue'
import News from './news.vue'
import Notice from './notice.vue'
import Aedu from './aedu.vue'
import Cedu from './cedu.vue'
import Dedu from './dedu.vue'
import Train from './train.vue'
import Quick from './quick.vue'
import Bottom from './bottom.vue'
export default {
  name: "index",
  data () {
    return {
      'banner':[],
      'news':[],
      'notice':[],
      'train':[],
      'academicCategoryList': [],
      'selfStudyCategoryList': [],
      'distanceCategoryList': [],
    }
  },
  components: {
    Top,
    Banner,
    News,
    Notice,
    Aedu,
    Cedu,
    Dedu,
    Train,
    Quick,
    Bottom,
  },
  created() {
    this.$request.get('home/index', {},response => {
      if(response.status == 200){
        this.banner = response.data.data.promotionBannerList;
        this.$refs.banner.dealBanner();
        this.news = response.data.data.newsList;
        this.notice = response.data.data.noticeList;
        this.train = response.data.data.promotionTrainingProgram;
        this.academicCategoryList = response.data.data.academicCategoryList;
        this.selfStudyCategoryList = response.data.data.selfStudyCategoryList;
        this.distanceCategoryList = response.data.data.distanceCategoryList;
      }
    },error => {
      console.log(error);
    })
  },
  mounted() {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue